import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import Tab from '../../../../component/Tabs/Tab';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const DetailCashBank = () => {
    const { code } = useParams();
    const navigate = useNavigate();

    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [totalRows, setTotalRows] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isNextPage, setIsNextPage] = useState(true);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [activeType, setActiveType] = useState("transaction");

    const tabHeader = [
        {
            "key": "transaction",
            "label": "Transaksi Jurnal",
        },
        {
            "key": "-",
            "label": "Rekening Koran"
        },
        {
            "key": "-",
            "label": "Rekonsiliasi"
        },
        {
            "key": "-",
            "label": "Pemetaan Kas"
        }
    ];

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_TRANSACTION = "api/erpppsu/account/transaction";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (activeType == 'transaction') {
            fetchData(`${BASE_URL}${PATH_TRANSACTION}?code_account=${code}`, {
                params: {
                    offset: pageIndex,
                    limit: pageSize
                }
            }).then((response) => {
                setData(response.data);
                setTotalRows(response.total);
            });
        } else {
            setData([]);
            setTotalRows(0);
            setIsNextPage(false);
        }
    }, [activeType]);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleTabClick = (tab) => {
        setActiveType(tab);
    };

    const options = [
        { value: 'transfer', label: 'Transfer Uang' },
        { value: 'bank-deposit', label: 'Terima Uang' },
        { value: 'withdrawal', label: 'Kirim Uang' }
    ];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="mx-auto p-4">
            <div className='flex items-center justify-between p-5'>
                <h2 className="text-2xl font-bold">Detail Akun</h2>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Buat Transaksi"}
                        options={options}
                        onChange={(value) => {
                            if (value == 'transfer') {
                                navigate(`/activity-erpppsu/cash-bank/transaction/transfer`);
                            } else if (value == 'bank-deposit' || value == 'withdrawal') {
                                navigate(`/activity-erpppsu/cash-bank/transaction/${value}`);
                            }
                        }}
                    />
                </div>
            </div>

            <div className="tabs">
                {tabHeader.map((tab) => (
                    <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
                        handleTabClick(tab.key)
                    }} />
                ))}
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTablePageDynamic
                    data={data}
                    nextPage={isNextPage}
                    columns={columns}
                    elementClass="p-1"
                    actions={[]}
                    onDataChange={(pageIndex, pageSize, sortBy) => {
                        setPageIndex(pageIndex);
                        fetchData(`${BASE_URL}${PATH_TRANSACTION}?code_account=${code}`, {
                            params: {
                                offset: pageIndex,
                                limit: pageSize
                            }
                        }).then((response) => {
                            setIsNextPage(response.more > 0);
                            setData(response.data);
                            setTotalRows(response.total);
                        });
                    }} />
            )}

            <p>
                Menampilkan {Math.min(pageSize + pageIndex, totalRows)} dari {totalRows} Baris
            </p>
        </div>
    );
}

export default DetailCashBank;
